import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Admin = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { name: "Packages", path: "/admin/packages/" },
    { name: "Package Category", path: "/admin/package-category/" },
    { name: "Offer", path: "/admin/offer/" },
    { name: "Opinions", path: "/admin/opinions/" },
    { name: "Information", path: "/admin/information/" },
  ];

  const isArabic = i18n.language === "ar";

  const isActive = (path) => location.pathname.includes(path);

  // Logout handler
  const handleLogout = () => {
    // Example: clear auth token or user data
    localStorage.removeItem("adminToken");
    // Redirect to login page
    navigate("/admin");
  };

  return (
    <div className={`min-h-screen flex bg-gray-100`}>
      {/* Sidebar */}
      <aside
        className={`w-64 bg-gray-800 text-white p-6 shadow-lg h-[100vh] sticky top-0 flex flex-col justify-between ${
          isArabic ? "right-0" : "left-0"
        }`}
      >
        <div>
          <h2
            className={`text-3xl font-bold mb-8 text-center ${
              isArabic ? "text-right" : "text-left"
            }`}
          >
            {isArabic ? "لوحة الإدارة" : "Admin Panel"}
          </h2>
          <nav className="space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`block px-4 py-2 rounded-lg transition-colors duration-300 flex items-center ${
                  isActive(item.path)
                    ? "bg-gray-600 text-white"
                    : "hover:bg-gray-700 text-gray-300"
                }`}
                style={{ textDecoration: "none" }}
              >
                <span className={`flex-grow ${isArabic ? "text-right" : "text-left"}`}>
                  {isArabic
                    ? item.name === "Package Category"
                      ? "نوع الباقة"
                      : item.name === "Packages"
                      ? "الباقة"
                      : item.name === "Offer"
                      ? "العروض"
                      : item.name === "Opinions"
                      ? "الآراء"
                      : "معلومات طبية"
                    : item.name}
                </span>
              </Link>
            ))}
          </nav>
        </div>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="mt-6 w-full flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-lg transition-all duration-300"
        >
          {isArabic ? "تسجيل الخروج" : "Logout"}
        </button>
      </aside>

      {/* Main Content */}
      <main
        className={`flex-1 p-8 bg-white rounded-lg shadow-lg ${
          isArabic ? "text-right" : "text-left"
        }`}
      >
        <Outlet /> {/* Nested routes will render here */}
      </main>
    </div>
  );
};

export default Admin;
